import { queryClient } from "@/constants";
import { CLIENT_API } from "@/services/axios-client";
import { useNotificationStore } from "@/states/zustand/notification";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useGetMeditatorAttendance = ({
    retreatId,
    page,
    limit = 10,
}: {
    retreatId: number;
    page: number;
    limit?: number;
}) => {
    return useQuery({
        queryKey: ["checkInCheckOutList"],
        queryFn: () =>
            CLIENT_API.getMeditationRetreatAttendance(retreatId, page, limit),
        enabled: !!retreatId
    });
};

export const useCheckInCheckOut = () => {
    return useMutation({
        mutationKey: ["checkInCheckOutList"],
        mutationFn: (meditatorId: number) =>
            CLIENT_API.checkInCheckOutMeditator(meditatorId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["attendances"],
            });
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: "error",
                message: error
            })
        }
    });
};
